export default __webpack_public_path__ + "static/Plain-Bold-2f04de1f32dba50d8d1c1fe39e69fcc6.woff";